import Navigation from './_navigation.js';
import Footer from './_footer.js';
import { factory as share } from './_share.js';
import throttle from './base/_throttle.js';
import focusWithin from './base/_focus-within.js';
import Breadcrumb from './_breadcrumb.js';
import touchFocus from './_touch-focus.js';
import objectFitCover from './_object-fit-cover.js';

class NLC {
	constructor() {
		document.addEventListener( 'DOMContentLoaded', this.ready.bind( this ) );
		window.addEventListener( 'resize', throttle( this.resize.bind( this ), 25 ) );
		this.resize();
	}

	ready() {
		this.navigation = new Navigation();
		this.footer = new Footer();
		this.shares = share();
		this.breadcrumbs = Array.from( document.querySelectorAll( '.breadcrumb' ) ).map( node => new Breadcrumb( node ) );
		this.notices();

		focusWithin( 'label, form, fieldset' );
		touchFocus( '.kard' );

		if ( ! ( 'objectFit' in document.documentElement.style ) ) {
			objectFitCover( '.page-header__image', 'img' );
			objectFitCover( '.kard--bg-image .kard__image', 'img' );
			objectFitCover( '.tabs-feature__media', 'img' );
		}
	}

	resize() {
		// using this to allow css to know if it should exclude the scroll bar in calc's
		if ( window.innerWidth === document.body.clientWidth ) {
			document.documentElement.classList.remove( 'has-scrollbar' );
		} else {
			document.documentElement.classList.add( 'has-scrollbar' );
		}
	}

	/**
	 * Add a dismiss button to any notice
	 */
	notices() {
		const notices = Array.from( document.querySelectorAll( '.notice' ) );

		if ( ! notices.length ) {
			return;
		}

		notices.forEach( notice => {
			const button = document.createElement('button');
			button.type = 'button';
			button.className = 'notice__dismiss';
			button.insertAdjacentHTML( 'beforeend', '<svg role="img" aria-label="Dismiss notice" class="svg--symbol svg--close" height="16" width="16" focusable="false"><use xlink:href="#icon-close"></use></svg>' );
			button.addEventListener('click', () => {
				// remove site and logout from the url history
				let url = location.origin + location.pathname;

				const params = new URLSearchParams( location.search );
				[ 'Site', 'logout' ].forEach( param => params.delete( param ) );
				const queryString = params.toString();

				if ( queryString.length ) {
					url += `?${queryString}`;
				}

				window.history.replaceState( {}, null, url );

				// remove the notice node
				notice.parentNode.removeChild( notice );
			} );
			notice.appendChild( button );
		} );
	}
}

export default new NLC;
